import React from 'react';
import { Container, Typography, Box, Paper, List, ListItem, ListItemText } from '@mui/material';
import SEO from '../components/SEO';

const TermsOfService = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <SEO
        title="Terms of Service - SOLID CLASSES"
        description="Read the terms and conditions for using SOLID CLASSES website and services. Covers user responsibilities, intellectual property, disclaimers, and governing law."
        keywords="terms of service, terms and conditions, SOLID CLASSES terms, coaching center terms"
      />
      <Typography variant="h3" component="h1" gutterBottom align="center">
        Terms of Service
      </Typography>
      <Typography variant="h6" color="text.secondary" paragraph align="center" sx={{ mb: 6 }}>
        Please read these terms and conditions carefully before using Our Service.
      </Typography>

      <Paper sx={{ p: { xs: 2, md: 4 } }}>
        <Typography variant="h5" component="h2" gutterBottom>
          1. Agreement to Terms
        </Typography>
        <Typography paragraph>
          By accessing or using the website of SOLID CLASSES (the "Service"), you agree to be bound by these Terms of Service ("Terms"). If you disagree with any part of the terms, then you may not access the Service.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          2. Intellectual Property
        </Typography>
        <Typography paragraph>
          The Service and its original content (excluding content provided by users), features, and functionality are and will remain the exclusive property of SOLID CLASSES and its licensors. The Service is protected by copyright, trademark, and other laws of both the India and foreign countries. Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of SOLID CLASSES.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          3. User Responsibilities
        </Typography>
        <Typography paragraph>
          You agree to use the Service only for lawful purposes and in a way that does not infringe the rights of, restrict or inhibit anyone else's use and enjoyment of the Service. Prohibited behavior includes harassing or causing distress or inconvenience to any other user, transmitting obscene or offensive content, or disrupting the normal flow of dialogue within our Service.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          4. Links to Other Websites
        </Typography>
        <Typography paragraph>
          Our Service may contain links to third-party web sites or services that are not owned or controlled by SOLID CLASSES. SOLID CLASSES has no control over, and assumes no responsibility for, the content, privacy policies, or practices of any third party web sites or services. You further acknowledge and agree that SOLID CLASSES shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any such content, goods or services available on or through any such web sites or services.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          5. Disclaimer of Warranties
        </Typography>
        <Typography paragraph>
          Your use of the Service is at your sole risk. The Service is provided on an "AS IS" and "AS AVAILABLE" basis. The Service is provided without warranties of any kind, whether express or implied, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, non-infringement or course of performance.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          6. Limitation of Liability
        </Typography>
        <Typography paragraph>
          In no event shall SOLID CLASSES, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from (i) your access to or use of or inability to access or use the Service; (ii) any conduct or content of any third party on the Service; (iii) any content obtained from the Service; and (iv) unauthorized access, use or alteration of your transmissions or content, whether based on warranty, contract, tort (including negligence) or any other legal theory, whether or not we have been informed of the possibility of such damage, and even if a remedy set forth herein is found to have failed of its essential purpose.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          7. Governing Law
        </Typography>
        <Typography paragraph>
          These Terms shall be governed and construed in accordance with the laws of India, without regard to its conflict of law provisions.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          8. Changes to Terms
        </Typography>
        <Typography paragraph>
          We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will try to provide at least 30 days notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
          9. Contact Us
        </Typography>
        <Typography paragraph>
          If you have any questions about these Terms, please contact us:
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="By email: solidclassesjodhpur@gmail.com"
            />
          </ListItem>
          <ListItem>
            <ListItemText primary="By phone number: +91 90790-35708"
            />
          </ListItem>
        </List>
      </Paper>
    </Container>
  );
};

export default TermsOfService; 
